export const data = [
  {
    title: 'We build solutions in 3 phases',
    description:
      'R&D and building the first solution, stabilization & feature engineering, production implementation and maintenance.',
  },
  {
    title: 'Evaluation of the performance after each phase',
    description:
      'Our team will firstly verify your idea so as not to waste your time and money.',
  },
  {
    title: 'Python implementation',
    description:
      'Our AI team is skilled in the Python language, the most commonly used for machine learning.',
  },
  {
    title: 'Cutting-edge infrastructure on demand',
    description:
      'We collaborate with Amazon Web Services and Google Compute Engine to offer you a stable infrastructure.',
  },
  {
    title: 'Scalable solution',
    description:
      'Our team creates a microservices infrastructure. The model is exposed via API and can be used from any platform.',
  },
  {
    title: 'Full integration with your existing software',
    description:
      'Boldare’s specialists, who programme in Python, PHP, Java, and JavaScript as well as mobile languages, are able to integrate the predictions from machine learning models with your current software.',
  },
];
